export const statusConsts = [
  { label: "Not sorted", id: "not_sorted" },
  { label: "Clarification", id: "clarification" },
  { label: "In process", id: "in_process" },
  { label: "Admission", id: "admission" },
  { label: "Reservation", id: "reservation" },
  { label: "Invitation", id: "invitation" },
  { label: "Visa app", id: "visa_app" },
];